/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Calendar_Birthday_SelfInputs */

const fr_calendar_birthday_self = /** @type {(inputs: Calendar_Birthday_SelfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Joyeux anniversaire ${i?.name} !`)
};

/**

* @param {Calendar_Birthday_SelfInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const calendar_birthday_self = /** @type {((inputs: Calendar_Birthday_SelfInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Birthday_SelfInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_calendar_birthday_self(inputs)
});